export const ContactActionPrefixes = {
  Call: 'global-action-button-call',
  Message: 'global-action-button-message',
  Quickfill: 'global-action-button-quickfill',
  Payments: 'global-action-button-payments',
  ReviewInvitation: 'global-action-button-review-invitation',
  SendForm: 'global-action-button-send-form',
};
